import BaseDetails from "./BaseDetails";

class CaseStudyDetails extends BaseDetails {
  constructor(name = "", description = "") {
    super(name, description);
  }
}

export default CaseStudyDetails;
